import { FilterSection, type FilterConfig } from "@/components/ui/FilterSection";
import { BULK_ACTIONS, STATUS_FILTER_OPTIONS, PRIORITY_FILTER_OPTIONS } from "@/lib/jobConstants";

interface JobFiltersSectionProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  statusFilter: string;
  setStatusFilter: (status: string) => void;
  priorityFilter: string;
  setPriorityFilter: (priority: string) => void;
  selectedJobs: string[];
  onBulkAction: (action: string) => void;
}

export function JobFiltersSection({
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  priorityFilter,
  setPriorityFilter,
  selectedJobs,
  onBulkAction
}: JobFiltersSectionProps) {
  const statusFilterConfig: FilterConfig = {
    placeholder: "Status",
    options: STATUS_FILTER_OPTIONS
  };

  const priorityFilterConfig: FilterConfig = {
    placeholder: "Priority",
    options: PRIORITY_FILTER_OPTIONS
  };

  return (
    <FilterSection
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
      searchPlaceholder="Search jobs, companies, locations..."
      filters={{
        status: {
          value: statusFilter,
          onChange: setStatusFilter,
          config: statusFilterConfig
        },
        priority: {
          value: priorityFilter,
          onChange: setPriorityFilter,
          config: priorityFilterConfig
        }
      }}
      useCard={true}
      selectedItems={selectedJobs}
      bulkActions={BULK_ACTIONS.map(action => ({
        action: action.action,
        label: action.label,
        icon: <action.icon className="h-4 w-4 mr-1" />
      }))}
      onBulkAction={onBulkAction}
    />
  );
}
